import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { FileSpreadsheet } from "lucide-react";

export default function ExportOwnersButton() {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get("/admin/owners/export", { responseType: "blob" });
      const name = (res.headers["content-disposition"] || "").match(/filename="([^"]+)"/)?.[1] || "verifine-owners.xlsx";
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = name;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Owner list downloaded");
    } catch {
      toast.error("Export failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button data-testid="export-owners-button" onClick={download} disabled={busy} className="btn-ghost inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm">
      {busy ? <span className="spin" /> : <FileSpreadsheet className="w-4 h-4" />}
      <span>Export owners</span>
    </button>
  );
}
